const userEndpoints = {
  login: "/user/login",
  verifyLoginOtp: "/user/verify-login-otp",
  logout: "/userLogout",
  listUser: "/user/details",
  UserDetails: "/user/userDetails",
  chartSave: "/charts/save",
  chartList: "/charts/list",
  chartDetails: "/charts/details",
  updateChartStatus: "/charts/updateStatus",
  saveContext: "/context/save",
  listContext: "/context/list",
  deleteContext: "/context/delete",
  listMembers: "/user/list",
  addMember: "/user/save",
  profileUpdate: "/user/save",
  uploadImage: "/user/upload",
  setPassword: "/user/setPassword",
  userTypes: "/usertype/list",
  forgotPassword: "/user/forgotpassword",
  resetpassword: "/user/resetpassword",
  resendMail: "/user/resendMail",
  validLink: "/user/validLink",
  archieveUser: "/user/archieveUser",
  deleteUser: "/user/delete",
  growthChartDetails: "/evaluation/graph",
  growthChartUserList: "/evaluation/evalualeeUserList",
  growthChartContext: "/context/list",
  growthChartEvaluationDetails: "/evaluation/getEvaluationDetails",
  getEvaluatedUserList: "/evaluation/evaluatedUserList",
  evaluationNarrativesDetails: "charts/details",
  onSaveEvaluation: "/evaluation/saveCCC",
  getCCCValuations: "/evaluation/getCCCValuations",
  publishCCC: "evaluation/publishCCCEvaluation",
  publishEvaluation: "evaluation/publishEvaluation",
  getCCCPublishedDetails: "evaluation/getCCCPublishedDetails",
  cccListing: "evaluation/cccListing",
  unEvaluatedList: "evaluation/cccUnevaluatedcharts",
  saveFeedback: "evaluation/saveFeedback",
  saveFeedbackNew: "evaluation/saveCCCTextOnly",
  evaluatedList: "evaluation/getcccconfirmationdetails",
  startCCCList: "evaluation/residentsList",
  getListChartDetails: "charts/listChartDetails",
  getFeedbackDetails: "evaluation/list",
  getHandOff: "handoff/list",
  evaluationDetails: "evaluation/getCCCDetails",
  saveEvaluation: "evaluation/save",
  saveCCCTextOnly: "evaluation/saveCCCTextOnly",
  listFeedbacks: "/evaluation/listFeedbacks",
  listCompetencyContexts: "/evaluation/listCompetencyContexts",
  listCaseLevels: "/evaluation/listCaseLevels",
  listCompetencyCharts: "/evaluation/listCompetencyCharts",
  listSkillCharts: "/evaluation/listSkillCharts",
  listSkillContexts: "/evaluation/listSkillContexts",
  listDepartment: "/program/list",
  myProgramsList: "userProgramMapping/list",
  listUsers: "/user/allUserList",
  listPrograms: "/program/list",
  sendInvitation: "/userProgramMapping/save",
  userInvite: "/user/inviteUser",
  // signUp: "/user/getInvitationDetails?PasswordLink=ssSWtQz9k8GGfzgO0gmD&ProgramID=1",
  signUp: "/user/getInvitationDetails?",
  validateEmail: "/user/validateEmail",
  disciplineList: "/discipline/list",
  degreeList: "/degree/list",
  emailresetpassword: "/user/setPassword",
  validateUser: "/userProgramMapping/validateSave",
  getGraduationDate: "/user/getGraduationDate",
  changePassword: "/user/changePassword",
  listOfInstitutions: "/user/myInstitution",
  institutionBasedPrograms: "/program/institutionBasedProgram",
  deleteCCC: "/evaluation/delete",
  skillsChart: {
    save: "/skills-chart/charts",
    get: "/skills-chart/details?ID=",
    list: "/skills-chart/charts?fromWeb=true&",
    saveContext: "/skills-chart/context",
    deleteContext: "/skills-chart/context",
    getContext: "/skills-chart/listContexts",
    getLevels: "/skills-chart/levels",
    update: "/skills-chart/charts?ID=",
    publish: "/skills-chart/publish",
    favorite: "/skills-chart/favorite",
    listFavorites: "/skills-chart/listFavorites",
    feedback: {
      list: "/skills-chart/feedback",
      save: "/skills-chart/feedback",
      update: "/skills-chart/feedback/",
      delete: "/skills-chart/feedback/",
      textOnly: "/skills-chart/cccTextOnlySkillFeedback",
    },
  },
  teams: {
    save: "teams/createTeam",
    list: "teams/listTeams",
    delete: "teams/delete",
  },
  programProfile: "/program/profile?userID=",
  listNarratives: "/evaluation/listNarratives?",
  getGraphData: "/evaluation/getGraphData?",
  masterTimeline: "/evaluation/masterTimeline?",
};

export { userEndpoints };
